import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You buy or sell stuff here. We host the stuff you buy or sell. We don't mean anything else to each other outside of that.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      